var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSearch = function SvgNoSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 11.5a7.25 7.25 0 0 1 13.044-4.359.75.75 0 1 0 1.198-.903A8.75 8.75 0 1 0 5.77 18.516a.75.75 0 0 0 .897-1.202A7.24 7.24 0 0 1 3.75 11.5m15.894-1.363a.75.75 0 1 0-1.482.232q.088.553.088 1.131c0 1.96-.778 3.74-2.043 5.044a.8.8 0 0 0-.163.163A7.23 7.23 0 0 1 11 18.75q-.546 0-1.07-.078a.75.75 0 0 0-.219 1.484q.632.093 1.289.094a8.7 8.7 0 0 0 5.634-2.055l3.836 3.835a.75.75 0 1 0 1.06-1.06l-3.835-3.836A8.7 8.7 0 0 0 19.75 11.5a9 9 0 0 0-.106-1.363",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m20 4.5-16 16"
  })));
};
export default SvgNoSearch;